<template>
  <div class="tableWithPerPageSelection">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('listeEcheancesAPayer.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab">
      <ul>
        <li :class="{'is-active': activeTab === 'listePaiementDirect'}"
            @click="activeTab = 'listePaiementDirect'">
          {{ $t('listeEcheancesAPayer.onglet.listePaiementDirect') }}
        </li>
        <li :class="{'is-active': activeTab === 'listePaiementFactureAchat'}"
            @click="changeActiveTabAndShareFiltre">
          {{ $t('listeEcheancesAPayer.onglet.listePaiementSurFacture') }}
        </li>
        <li :class="{'is-active': activeTab === 'listePaiementsARappocher'}"
            @click="activeTab = 'listePaiementsARappocher'">
          {{ $t('listeEcheancesAPayer.onglet.listePaiementARapprocher') }}
        </li>
      </ul>
    </div>
    <component :is="activeTab" :moduleDcf="constantes.MODULE_BAIL">
    </component>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import messageErreur from '@/services/general/messageErreur';
import listePaiementDirect from '@/components/baux/paiement/listePaiementDirect';
import listePaiementFactureAchat from '@/components/paiement/listePaiementFactureAchat';
import listePaiementsARappocher from '@/components/baux/paiement/listePaiementARappocher';
import genererCritereRecherchePaiementSurFacture
  from '@/services/baux/echeancesAPayer/genererCritereRecherchePaiementSurFacture';
import { SET_CRITERE_RECHERCHE, SET_DISPLAY_FACTURES_ANT } from '@/store/modules/baux/paiementSurFacture-mutation-type';
import { MODULE_BAIL } from '@/configuration/devisConf';

const EcheancesAPayer = createNamespacedHelpers('echeancesAPayer');
const PaiementSurFacture = createNamespacedHelpers('paiementSurFacture');

export default {
  data() {
    return {
      activeTab: 'listePaiementDirect',
      firstSwipe: true,
      constantes: {
        MODULE_BAIL,
      },
    };
  },
  components: {
    breadcrumb,
    listePaiementDirect,
    listePaiementFactureAchat,
    listePaiementsARappocher,
  },
  methods: {
    ...PaiementSurFacture.mapMutations({
      setCritereRecherche: SET_CRITERE_RECHERCHE,
      setDisplayFacturesAnt: SET_DISPLAY_FACTURES_ANT,
    }),
    changeActiveTabAndShareFiltre() {
      if (this.firstSwipe) {
        const newCriterePaiementSurFacture = genererCritereRecherchePaiementSurFacture();
        newCriterePaiementSurFacture.validateurs = cloneDeep(this.critereRecherche.validateurs);
        newCriterePaiementSurFacture.dates = cloneDeep(this.critereRecherche.datesEcheance);
        newCriterePaiementSurFacture.bonAPayer = cloneDeep(this.critereRecherche.bonAPayer);
        newCriterePaiementSurFacture.commentaire = cloneDeep(this.critereRecherche.commentaire);
        newCriterePaiementSurFacture.nomBailleur = cloneDeep(this.critereRecherche.nomBailleur);
        newCriterePaiementSurFacture.referencePaiement = cloneDeep(
          this.critereRecherche.referencePaiement,
        );
        newCriterePaiementSurFacture.modeReglementId = cloneDeep(
          this.critereRecherche.modeReglementId,
        );
        newCriterePaiementSurFacture.blocageReglement = cloneDeep(
          this.critereRecherche.blocageReglement,
        );
        this.setCritereRecherche(newCriterePaiementSurFacture);
        this.setDisplayFacturesAnt(this.displayEcheancesAnt);
        this.firstSwipe = false;
      }
      this.activeTab = 'listePaiementFactureAchat';
    },
  },
  computed: {
    ...EcheancesAPayer.mapGetters({
      critereRecherche: 'criteresRecherche',
      displayEcheancesAnt: 'displayEcheancesAnt',
    }),
    breadcrumb() {
      return [
        { title: this.$t('listeEcheancesAPayer.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('listeEcheancesAPayer.breadcrumb.liste'), route: '', isActive: true },
      ];
    },
  },
  mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      this.setInformationPage(this.$t('pageBaux.echeancesAPayer.liste'));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};

</script>
